import { Route } from '@supsupclub/types';
import {
  AuthRedirect,
  FORGOT_PASSWORD_PATH,
  RESET_PASSWORD_PATH,
  SIGN_IN_PATH,
  SIGN_UP_PATH,
} from '@supsupclub/ui-components';
import { lazy } from 'react';

const ForgotPasswordView = lazy(() =>
  import('./views/forgot-password').then((m) => ({
    default: m.ForgotPasswordView,
  })),
);
const ResetPasswordView = lazy(() =>
  import('./views/reset-password').then((m) => ({
    default: m.ResetPasswordView,
  })),
);
const SignInView = lazy(() =>
  import('./views/sign-in').then((m) => ({ default: m.SignInView })),
);
const SignUpView = lazy(() =>
  import('./views/sign-up').then((m) => ({ default: m.SignUpView })),
);

export const authRoutes: Route[] = [
  {
    path: SIGN_IN_PATH,
    hideFromMenu: true,
    element: (
      <AuthRedirect withoutAuth>
        <SignInView />
      </AuthRedirect>
    ),
  },
  {
    path: SIGN_UP_PATH,
    hideFromMenu: true,
    element: (
      <AuthRedirect withoutAuth>
        <SignUpView />
      </AuthRedirect>
    ),
  },
  {
    path: FORGOT_PASSWORD_PATH,
    hideFromMenu: true,
    element: (
      <AuthRedirect withoutAuth>
        <ForgotPasswordView />
      </AuthRedirect>
    ),
  },
  {
    path: RESET_PASSWORD_PATH,
    hideFromMenu: true,
    element: (
      <AuthRedirect withoutAuth>
        <ResetPasswordView />
      </AuthRedirect>
    ),
  },
];
